export type ResearchProgram = { type: string; name: string; line: string; href?: string };

export const researchPrograms: ResearchProgram[] = [
  {
    type: "Framework",
    name: "Payroll Maturity Model™",
    line: "A five-stage model for assessing how well payroll and the systems behind it are run.",
    href: "#maturity-model",
  },
  {
    type: "Annual report",
    name: "State of Payroll Operations",
    line: "Our yearly study of how payroll and HR technology teams are staffed, supported, and where they break.",
    href: "#state-of-payroll",
  },
  {
    type: "Comparative data",
    name: "Benchmarking",
    line: "How your function compares on accuracy, effort per cycle, staffing, and system use.",
  },
  {
    type: "Studies",
    name: "Original Research",
    line: "Focused studies on implementations, configuration, integrations, and payroll operations.",
  },
  {
    type: "Datasets",
    name: "Industry Data",
    line: "Field data on vendor changes, implementation timelines, and error patterns.",
  },
  {
    type: "Private sessions",
    name: "Executive Briefings",
    line: "Briefings for CFOs, CHROs, and their teams on what the findings mean for them.",
    href: "#briefings",
  },
];

export type MaturityLevel = { numeral: string; name: string; line: string };

export const maturityLevels: MaturityLevel[] = [
  { numeral: "I", name: "Reactive", line: "Payroll gets done, but employees find the errors. Systems are set up however they were left." },
  { numeral: "II", name: "Stable", line: "Payroll runs on time. Little is written down, and it depends on one or two people." },
  { numeral: "III", name: "Defined", line: "Processes, calendars, and system settings are documented. Checks exist but aren’t always followed." },
  { numeral: "IV", name: "Controlled", line: "Checks, reconciliations, and system changes happen the same way every cycle. Audits are routine." },
  { numeral: "V", name: "Exceptional", line: "Payroll and HR technology are run deliberately — measured, resilient, and never dependent on one person." },
];

export const reportChapters: string[] = [
  "Who runs payroll — and what happens when they leave",
  "HRIS implementations, eighteen months after go-live",
  "Manual work: where the hours actually go",
  "Checks that exist versus checks that happen",
];

export type AgendaItem = { study: string; area: "Payroll" | "HR Technology"; status: string; expected: string };

export const researchAgenda: AgendaItem[] = [
  { study: "The real cost of a failed HRIS implementation", area: "HR Technology", status: "In field", expected: "Q1 2027" },
  { study: "Payroll staffing by company size and complexity", area: "Payroll", status: "In analysis", expected: "Q1 2027" },
  { study: "Where HRIS-to-payroll integrations break", area: "HR Technology", status: "In field", expected: "Q2 2027" },
  { study: "The multi-state payroll workload", area: "Payroll", status: "Scoping", expected: "Q3 2027" },
  { study: "Configuration drift in year two", area: "HR Technology", status: "Scoping", expected: "Q3 2027" },
];
